import { ActivityEntityName } from '@jms/model';

/** Create-dialog header noun. Presentation title wins; otherwise metadata displayName; hyphenated keys become spaces so Recurring-Job is readable before metadata lands. */
export function entityDialogCreateTitle(entity: ActivityEntityName, displayName?: string | null, presentationTitle?: string | null): string {

  if (presentationTitle) return presentationTitle;
  const noun = displayName?.trim() || String(entity).replaceAll('-', ' ');
  return `Create New ${noun}`;
}
